import { observer } from "mobx-react";
import Modal from 'react-bootstrap/Modal';
import productosStore from '../stores/ProductosStore';
import { Download } from "./Catalogo";

const ModalOfertasSemanales = (props) => {
    return (
        <Modal
            show={productosStore.showOfertasModal}
            onHide={() => productosStore.setShowOfertasModal(false)}
            backdrop={'static'}
            keyboard={false}
            className="descarga-catalogo"
        >
            <Modal.Header>
                <h4 className="modal-title " id="">DESCARGA LOS ARCHIVOS CON LAS OFERTAS SEMANALES</h4>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => productosStore.setShowOfertasModal(false)}
                ></button>
            </Modal.Header>
            <div className="modal-body">
                <div className="row">
                    <div className="col-12" style={{ textAlign: 'center' }}>
                        <h4>OFERTAS SEMANALES DE DISTRICENTRO FERRETERA</h4>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className={'table'}>
                            <tr>
                                <td style={{textAlign: 'center' }} className={'file'}>
                                    <Download
                                        id={16}
                                        url='/cdn/archivos/3.xls'
                                        filename='NovedadesYOfertas'
                                        extension='xls'
                                    />
                                </td>
                                <td style={{textAlign: 'center' }} className={'file'}>
                                    <Download
                                        id={15}
                                        url='/cdn/archivos/4.pdf'
                                        filename='NovedadesYOfertas'
                                        extension='pdf'
                                    />
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default observer(ModalOfertasSemanales);